module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/FinishZero-004462adc5612bc91dbb17a5832c221c.png";